// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Overview_wrapper__1fYDp","item":"Overview_item__PULIG","itemTitle":"Overview_itemTitle___Yaze","itemDesc":"Overview_itemDesc__2BrRB"};